var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('carousel',{attrs:{"perPage":1,"autoplay":true,"autoplayTimeout":10000}},_vm._l((_vm.urls),function(url,index){return _c('slide',{key:index},[_c('movie-container',{attrs:{"url":_vm.youtubeUrl(url)}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }